import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IAuthState, IAppState, IUserProfile } from '../shared/models/store.model'
import { logOutApp } from '.'

const initialState: IAuthState = {
  accessToken: '',
  refreshToken: '',
  accessExpiresIn: 0,
  refeshExpiresIn: 0,
  userProfile: {
    userId: '',
    name: '',
    userName: '',
    email: '',
    tenantId: '',
    status: '',
    role: '',
    policies: [],
  },
  accessTokenExpiresAt: 0,
}

const authReducer = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn(state: IAuthState, action: PayloadAction<Partial<IAuthState>>) {
      return { ...state, ...action.payload }
    },

    updateTokenWillExpiresAt(state: any, action: PayloadAction<any>) {
      state.accessTokenExpiresAt = action.payload
    },

    setUserProfile(state: IAuthState, action: PayloadAction<IUserProfile>) {
      return { ...state, userProfile: action.payload }
    },
  },
  extraReducers: (builder: any) => {
    builder.addCase(logOutApp, () => {
      return initialState
    })
  },
})

const rootState = (state: IAppState) => state.auth

export const getAccessToken = createSelector(rootState, (state: IAuthState) => state.accessToken)
export const getRefreshToken = createSelector(rootState, (state: IAuthState) => state.refreshToken)
export const getAccessTokenExpiresIn = createSelector(rootState, (state: IAuthState) => state.accessExpiresIn)
export const getAccessTokenExpiresAt = createSelector(rootState, (state: IAuthState) => state.accessTokenExpiresAt)
export const getAuthInfo = createSelector(rootState, (state: IAuthState) => state)
export const getUserProfile = createSelector(rootState, (state: IAuthState) => state.userProfile)

export const { logIn, setUserProfile, updateTokenWillExpiresAt } = authReducer.actions

export default authReducer
